export type StartsWithReturnType = string;

export type FullMatchReturnType = string;

export type BooleanReturnType = true | undefined;

/**
 * dateTime options describing a rolling window that ends at "now", rather than carrying a
 * date of their own. Exported as the single source of truth because both the URL
 * serializer and the SQL layer have to branch on this exact set: EDUS-2915 was caused by
 * the two keeping their own copies and drifting, which made every relative filter
 * silently return unfiltered rows.
 */
export const RelativeDateTimeMatcherOptions = ['lastHour', 'lastDay', 'lastWeek'] as const;

export type RelativeDateTimeMatcherOption =
  (typeof RelativeDateTimeMatcherOptions)[number];

/**
 * Narrows an untrusted option name — these arrive via JSON.parse of a request body or a
 * URL param, so the static type is not a runtime guarantee. Uses an array membership test
 * rather than `in` on an object so inherited keys ('constructor', 'toString') cannot pass.
 */
export const isRelativeDateTimeMatcherOption = (
  option: unknown
): option is RelativeDateTimeMatcherOption =>
  typeof option === 'string' &&
  (RelativeDateTimeMatcherOptions as readonly string[]).includes(option);

export type DateTimeMatcherOptions =
  | RelativeDateTimeMatcherOption
  | 'beforeDateTime'
  | 'sinceDateTime'
  | 'betweenDateTime';

export type DateTimeReturnType = {
  option: DateTimeMatcherOptions;
  value: string | { start: string; end: string };
};

export type InPastDayReturnType = true | undefined;

export type InPastHourReturnType = true | undefined;

export type InPastWeekReturnType = true | undefined;

export type OneOfReturnType = string;

export type SelectFromReturnType = string[];
